import { Trans } from "react-i18next";
import { ZENDESK_URLS } from "../../../../common/constants";
import { useRedirect } from "../../../../common/hooks/useRedirect";

const UserRolesInfoLink = () => {
    const { triggerZendeskRedirect } = useRedirect();

    return (
        <div className="text-base font-normal font-text">
            <Trans
                i18nKey="profile:roleInfoText"
                components={{
                    link1: (
                        <span
                            className="font-medium text-info-500 hover:underline cursor-pointer"
                            onClick={() =>
                                triggerZendeskRedirect(ZENDESK_URLS.USER_ROLES)
                            }
                        />
                    ),
                }}
            />
        </div>
    );
};

export default UserRolesInfoLink;
